import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

export default function BackgroundParticles() {
  const particles = useMemo(() => {
    return Array.from({ length: 40 }).map((_, i) => {
      // Vibrant red and cyan matching the reference image
      const color = Math.random() > 0.5 ? '#ff2a5f' : '#00e5ff';

      const startX = Math.random() * 100; // Random horizontal start

      // Horizontal drift amount
      const driftX = (Math.random() - 0.5) * 20;

      // Small sizes for the "balls/dust"
      const size = Math.random() * 2 + 2;

      // Delay so they don't all start at once
      const delay = Math.random() * -30;

      return {
        id: i,
        color,
        size,
        startX,
        driftX: `${driftX}vw`,
        duration: Math.random() * 10 + 10, // 10s to 20s (faster but comfortable background flow)
        delay
      };
    });
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {/* Moving Floating Balls */}
      <div className="absolute inset-0 mix-blend-screen opacity-80">
        {particles.map((p) => (
          <motion.div
            key={p.id}
            className="absolute rounded-full"
            style={{
              width: p.size,
              height: p.size,
              backgroundColor: p.color,
              boxShadow: `0 0 12px 3px ${p.color}`,
              left: `${p.startX}%`,
            }}
            initial={{ y: "110vh" }}
            animate={{
              y: ["110vh", "-10vh"],
              x: [0, p.driftX, 0],
            }}
            transition={{
              y: {
                duration: p.duration,
                repeat: Infinity,
                ease: "linear",
                delay: p.delay,
              },
              x: {
                duration: p.duration * 1.5,
                repeat: Infinity,
                ease: "easeInOut",
                delay: p.delay,
              }
            }}
          />
        ))}
      </div>
    </div>
  );
}
